module.exports = __webpack_public_path__ + "static/media/HomePic4.d87f4a64.jpg";